import styled from 'styled-components';

export const BannerFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px 0;
  margin-bottom: 20px;
  border: 1px solid #cbd5e1;
  padding: 16px 24px 16px 24px;
  gap: 12px;
  border-radius: 16px;
  opacity: 0px;
  position: relative;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CloseBannerContainer = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
`;

export const ImageContainer = styled.div``;
export const Image = styled.img`
  width: 28px;
  height: 32px;
`;

export const HeadingAndDescriptionContainer = styled.div`
  width: 100%;
`;

export const Description = styled.span``;

export const Heading = styled.span``;
